var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "select-rates",
    {
      attrs: { "bid-id": _vm.bidId, "force-save": true },
      on: { cancel: _vm.cancel, hide: _vm.hide, submit: _vm.hide },
    },
    [
      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
        _c("div", { class: _vm.$style.header }, [
          _c("img", {
            class: _vm.$style.headerIcon,
            attrs: {
              src: require("images/ui/icon-warning.svg"),
              alt: "Warning",
            },
          }),
          _c("div", [
            _c("h1", { class: _vm.$style.headerMain }, [
              _c("span", { class: _vm.$style.headerMainText }, [
                _vm._v("Notice!"),
              ]),
            ]),
          ]),
        ]),
        _c("div", { class: _vm.$style.modalBody }, [
          _c("div", { class: _vm.$style.bodyText }, [
            _vm._v(
              " We recognized you have just changed rates. Revise the rates you want to put on the Final Agreement. "
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }